import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function NewsSection() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="site-container px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 bg-accent-50 text-accent-700 text-xs font-semibold rounded-full mb-3">
              新闻资讯
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              最新动态
            </h2>
          </div>
          <Link
            to="/category?tab=news"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.summary}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{article.readCount.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category?tab=news"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部新闻 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}